<template>

    <ui-view class="view-lot-form" v-spinner="loading" :hide="loading">

        <ui-heading :title="pageTitle" icon="magicon-resize-plus-3">
            <ui-button
                v-if="$can('MUTATE_PARCELS')"
                color="positive"
                :loading="submitting"
                @click="$refs.form.submit()">Opslaan</ui-button>
            <ui-button
                v-if="parcelId && $can('MUTATE_PARCELS')"
                color="negative"
                icon="magicon-trash"
                @click="deleteParcel">Verwijderen</ui-button>

            <ui-button
                color="medium"
                type="bordered"
                @click="$router.go(-1)"
                slot="left">Annuleren</ui-button>
        </ui-heading>

        <ui-form-panel auto-validate ref="form" @submit="submit">

            <ui-form-dropdown
                searchable
                title="Perceel"
                name="parcelLocationId"
                :options="parcelLocationOptions"
                rules="required"
                v-model="pendingParcel.parcelLocationId"/>

            <ui-form-input
                title="Perceel oppervlakte (ha)"
                name="size"
                rules="required"
                decimal
                v-model="pendingParcel.size"/>

            <ui-form-input title="Alias" name="alias" v-model="pendingParcel.alias"/>

        </ui-form-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import { clone, pick } from 'es-toolkit';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import FindParcelQuery from 'gql/queries/ParcelForm/FindParcel.gql';
import AllParcelLocationsQuery from 'gql/queries/ParcelForm/AllParcelLocations.gql';

import ParcelMutations from 'app/mutations/ParcelMutations';

@Component({

    name: 'ParcelForm',
    apollo: {
        parcel: createQuery(FindParcelQuery, {

            skip() {

                return !this.parcelId;
            },

            variables() {

                return {
                    id: this.parcelId
                };
            },

            response(response) {

                this.pendingParcel = pick(response, Object.keys(this.pendingParcel));
            }
        }),
        parcelLocations: createQuery(AllParcelLocationsQuery)
    }
})
export default class ParcelForm extends Vue
{
    loading = 0;
    submitting = false;

    pendingParcel = {
        parcelLocationId: null,
        size: null,
        alias: null
    };

    breadcrumb(){

        return [{
            title: 'Percelen',
            route: {
                name: 'parcels'
            }
        }, this.pageTitle];
    }

    async submit() {

        if(!this.$can('MUTATE_PARCELS')) {
            return;
        }

        this.submitting = true;
        let input = clone(this.pendingParcel);

        try {

            if(this.parcelId) {

                input.id = this.parcelId;

                await ParcelMutations.update(input);

                this.logger.info('Parcel updated');
                this.$toast.success('Het perceel is aangepast');
            }
            else {

                input.growerId = this.$user.growerId;

                await ParcelMutations.create(input);

                this.logger.info('Parcel created');
                this.$toast.success('Het perceel is aangemaakt');
            }

            this.$router.replace({
                name: 'parcels'
            });
        }
        catch(e) {

            this.logger.error('Error creating/updating parcel', e);
            this.$toast.error('Het perceel kon niet worden opgeslagen');
        }

        this.submitting = false;
    }

    async deleteParcel() {

        if(!this.$can('MUTATE_PARCELS')) {
            return;
        }

        const { result, overlay } = await this.$alert.delete('Weet je zeker dat je dit perceel wilt verwijderen?', true, {
            subtitle: 'Ook alle bijbehorende vakken en voorgaande acties zullen worden verwijderd!'
        });

        if(!result) {
            return;
        }

        const id = this.parcelId;
        try {

            await ParcelMutations.delete(id);

            this.$toast.success('Het perceel is succesvol verwijderd');
            this.$router.replace({ name: 'parcels' });
        }
        catch(e) {

            this.logger.error(`Something went wrong while deleting parcel ${id}:`, e);
            this.$toast.error('Er is iets fout gegaan tijdens het verwijderen van het perceel');
        }

        this.$overlay.close(overlay);
    }

    get parcelId() {

        return this.$route.params.id;
    }

    get pageTitle(){

        return this.parcelId ? 'Perceel aanpassen' : 'Perceel aanmaken';
    }

    get parcelLocationOptions() {

        if(!this.parcelLocations) {
            return [];
        }

        return this.parcelLocations.items.map(location => ({
            label: `${location.name} ${location.number}`,
            value: location.id
        }));
    }
}

</script>